import type { DefaultIconProps } from '../../../utils';
import { DefaultIconWrapper } from '../../../utils';

export const CustomerServiceIllustration = ({
  width = 35,
  marginLeft,
  marginRight,
  containerSize,
}: DefaultIconProps) => (
  <DefaultIconWrapper marginLeft={marginLeft} marginRight={marginRight} containerSize={containerSize} width={width}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 35 51">
      <g fill="none" fillRule="evenodd">
        <path
          fill="#F8BB9F"
          d="M20.761 33.643v-3.618l-7.463-.012v3.624l-3.72.886v1.561c0 2.275 3.336 4.12 7.449 4.12 4.113 0 7.448-1.845 7.448-4.12v-1.56l-3.714-.881z"
        />
        <path
          fill="#000"
          fillOpacity=".15"
          d="M13.298 30.013v3.483c-.003.049-.006.098-.006.147 0 1.459 1.672 2.641 3.735 2.641 2.062 0 3.734-1.182 3.734-2.641v-3.63h-7.463z"
        />
        <path
          fill="#ED585D"
          d="M17.027 39.948c-4.114 0-7.448-1.72-7.448-3.844V51h14.896V36.104c0 2.123-3.335 3.844-7.448 3.844"
        />
        <path
          fill="#00396C"
          d="M24.474 34.523L19.521 51h13.296c.723 0 1.292-.618 1.232-1.34l-.733-8.753c-.212-2.538-2.013-4.66-4.482-5.283l-4.36-1.1z"
        />
        <path fill="#000" fillOpacity=".1" d="M17.027 39.948c-4.114 0-7.448-1.72-7.448-3.844V51h7.466V39.948h-.018" />
        <path
          fill="#00396C"
          d="M9.579 34.523L14.533 51H1.236c-.723 0-1.292-.618-1.232-1.34l.733-8.753c.213-2.538 2.014-4.66 4.483-5.283l4.359-1.1z"
        />
        <path
          fill="#F8BB9F"
          d="M25.08 20.166c-.482-5.697-3.923-10.115-8.096-10.115-4.174 0-7.615 4.418-8.097 10.115-.929.04-1.083 5.685.572 5.815v-.001c1.232 4.143 4.137 7.055 7.525 7.055 3.387 0 6.292-2.912 7.524-7.055v.001c1.655-.13 1.5-5.774.572-5.815"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M13.543 21.543c0-5.148 1.958-9.552 4.728-11.35-.42-.093-.85-.142-1.287-.142-4.174 0-7.615 4.418-8.097 10.115-.929.04-1.082 5.685.572 5.815v-.001c1.232 4.143 4.137 7.055 7.525 7.055.438 0 .868-.05 1.287-.143-2.77-1.797-4.728-6.201-4.728-11.35"
        />
        <path
          fill="#6E4848"
          d="M16.864.74c3.225 0 5.84 2.18 5.84 4.869 0 2.69-2.615 4.87-5.84 4.87-3.226 0-5.84-2.18-5.84-4.87s2.614-4.87 5.84-4.87"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M20.517 9.263c-3.228 0-5.84-2.18-5.84-4.87 0-1.45.767-2.75 1.977-3.642-3.127.096-5.624 2.235-5.624 4.858 0 2.69 2.617 4.87 5.84 4.87 1.485 0 2.839-.468 3.869-1.228-.078.006-.15.012-.222.012"
        />
        <path
          fill="#6E4848"
          d="M29.256 16.222c0-6.599-5.548-11.949-12.392-11.949-6.845 0-12.393 5.35-12.393 11.95 0 3.554 1.61 6.745 4.164 8.933-.12-1.297.339-3.305.317-4.562.087-1.034.273-2.026.542-2.957.2.146.433.241.687.275 2 .245 6.918.599 10.117-1.318.383-.228.85-.27 1.263-.108.623.24 1.54.599 2.247.88.24.094.498.12.739.082.3.985.505 2.041.598 3.146 0 1.147.376 2.918.346 4.205 2.322-2.171 3.765-5.211 3.765-8.577"
        />
        <path
          fill="#000"
          fillOpacity=".1"
          d="M8.63 25.078c-.12-1.297.338-3.305.316-4.562.087-1.034.273-2.026.542-2.957.2.146.433.241.687.275.155.019.328.038.515.058.093-6.06 4.137-11.191 9.761-13.11-1.138-.329-2.342-.509-3.587-.509-6.847 0-12.393 5.349-12.393 11.95 0 .29.011.58.033.866.257 3.172 1.8 5.996 4.125 7.99"
        />
        <path
          fill="#959CB5"
          d="M9.412 25.332c0 .132-.108.24-.24.24H7.465c-1.078 0-1.946-.875-1.946-1.947v-1.947c0-1.078.874-1.946 1.946-1.946h1.707c.132 0 .24.107.24.24v5.36zM26.937 19.732c1.078 0 1.947.874 1.947 1.946v1.947c0 1.078-.875 1.947-1.947 1.947H25.47c-.264 0-.478-.215-.478-.48v-5.121c0-.132.107-.24.239-.24h1.707z"
        />
        <path
          fill="#7F8499"
          d="M25.661 25.212c-.856.593-3.444 1.947-9.032 1.947-.539 0-.976.437-.976.976 0 .54.437.976.976.976 7.96 0 10.524-2.551 10.793-2.839.27-.3.3-1.054-.677-1.054h-1.084v-.006z"
        />
        <path
          fill="#464655"
          d="M18.33 29.063c.15-.275.246-.592.246-.928 0-.377-.114-.725-.294-1.018-.521.03-1.066.048-1.653.048-.539 0-.976.437-.976.976 0 .54.437.976.976.976.605-.012 1.162-.03 1.701-.054"
        />
      </g>
    </svg>
  </DefaultIconWrapper>
);
